module.exports = __webpack_public_path__ + "static/media/user-4.dc0d731a.svg";